import get from 'get-object-path';

export const userPermissions = {
    namespaced: true,

    getters: {
        permissions(state, getters, rootState, rootGetters) {
            return get(rootGetters.selectedClub, 'permissions.data') || [];
        },

        canViewAthleteProfile(state, getters) {
            return hasGivenPermission(getters.permissions, 'view-athlete-profile');
        },

        canViewClubMembers(state, getters) {
            return hasGivenPermission(getters.permissions, 'manage-members');
        },

        canInviteMembers(state, getters) {
            return hasGivenPermission(getters.permissions, 'invite-members');
        },

        canManageLicense(state, getters) {
            return hasGivenPermission(getters.permissions, 'manage-licences');
        },

        canManageInventory(state, getters) {
            return hasGivenPermission(getters.permissions, 'manage-inventory');
        },

        canCreateSquads(state, getters) {
            return hasGivenPermission(getters.permissions, 'create-squads');
        },

        canEditSquads(state, getters) {
            return hasGivenPermission(getters.permissions, 'edit-squads');
        },

        canDeleteSquads(state, getters) {
            return hasGivenPermission(getters.permissions, 'delete-squads');
        },

        canViewEditAllSessions(state, getters) {
            return hasGivenPermission(getters.permissions, 'view-edit-all-sessions');
        },

        canViewDrvPersonalDetails(state, getters) {
            return hasGivenPermission(getters.permissions, 'drv-view-personal-details');
        },

        // todo this permission will be temporarily removed
        canViewDrvProfileTab(state, getters) {
            return hasGivenPermission(getters.permissions, 'drv-view-personal-details');
            // return hasGivenPermission(getters.permissions, 'view-drv-tab-on-profile');
        },

        canImportDrvFile(state, getters) {
            return hasGivenPermission(getters.permissions, 'drv-import-files');
        },

        canViewAllMembersErgoProgressReport(state, getters) {
            return hasGivenPermission(getters.permissions, 'view-all-members-on-ergo-progress-report');
        },

        canViewAllMembersWaterProgressReport(state, getters) {
            return hasGivenPermission(getters.permissions, 'view-all-members-on-water-progress-report');
        },

        canViewAllMembersGmtReport(state, getters) {
            return hasGivenPermission(getters.permissions, 'view-all-members-on-gmt-report');
        },

        canViewAllMembersRpeReport(state, getters) {
            return hasGivenPermission(getters.permissions, 'view-all-members-on-rpe-report');
        },

        canViewAllMembersAttendanceReport(state, getters) {
            return hasGivenPermission(getters.permissions, 'view-all-members-on-attendance-report');
        },

        canViewAllMembersTrainingSummaryReport(state, getters) {
            return hasGivenPermission(getters.permissions, 'view-all-members-on-training-summary-report');
        },

        canViewAllMembersMorningMonitoringReport(state, getters) {
            return hasGivenPermission(getters.permissions, 'view-all-members-on-morning-monitoring-report');
        },

        canViewAllMembersStepTest(state, getters) {
            return hasGivenPermission(getters.permissions, 'drv-view-all-members-on-step-test-report');
        },

        canViewAllMembersVo2Test(state, getters) {
            return hasGivenPermission(getters.permissions, 'drv-view-all-members-on-vo2-test-report');
        },

        canViewAllMembers2kTest(state, getters) {
            return hasGivenPermission(getters.permissions, 'drv-view-all-members-on-2k-test-report');
        },

        canViewAllMembers6kTest(state, getters) {
            return hasGivenPermission(getters.permissions, 'drv-view-all-members-on-6k-test-report');
        },

        canViewAllMembers5kTest(state, getters) {
            return hasGivenPermission(getters.permissions, 'drv-view-all-members-on-5k-test-report');
        },

        canViewRacingReport(state, getters) {
            return hasGivenPermission(getters.permissions, 'view-racing-report');
        },

        manageChallenges(state, getters) {
            return hasGivenPermission(getters.permissions, 'manage-challenges');
        },

        manageChallengeTeams(state, getters) {
            return hasGivenPermission(getters.permissions, 'manage-challenge-teams');
        },

        canEditClub(state, getters) {
            return hasGivenPermission(getters.permissions, 'edit-club');
        }
    }
};

function hasGivenPermission(permissions, permissionId) {
    return !!permissions.find(permission => get(permission, 'permission.data.id') === permissionId);
}

export default userPermissions;
